var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticClass: "spu-title" }, [_c("custom-breadcrumb")], 1),
      _vm._v(" "),
      _c(
        "div",
        [
          _c(
            "el-form",
            { attrs: { model: _vm.form } },
            [
              _c(
                "el-form-item",
                { attrs: { label: "Title", required: true } },
                [
                  _c("el-input", {
                    attrs: { maxlength: "120", "show-word-limit": "" },
                    model: {
                      value: _vm.form.title,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "title", $$v)
                      },
                      expression: "form.title"
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: !_vm.form.title,
                          expression: "!form.title"
                        }
                      ],
                      staticClass: "required-form-error"
                    },
                    [_vm._v("Product title can't be blank")]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "Category", required: true } },
                [
                  _c("br"),
                  _vm._v(" "),
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "40%" },
                      attrs: {
                        filterable: "",
                        placeholder: "Please Select Category"
                      },
                      model: {
                        value: _vm.form.cateId,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "cateId", $$v)
                        },
                        expression: "form.cateId"
                      }
                    },
                    _vm._l(_vm.categoryList, function(item) {
                      return _c("el-option", {
                        key: item.value,
                        attrs: { label: item.label, value: item.value }
                      })
                    }),
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: !_vm.form.cateId,
                          expression: "!form.cateId"
                        }
                      ],
                      staticClass: "required-form-error"
                    },
                    [_vm._v("Product Category can't be blank")]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "Description", required: true } },
                [_c("div", { attrs: { id: "editor" } })]
              ),
              _vm._v(" "),
              _c("el-form-item", [
                _c("div", { attrs: { slot: "label" }, slot: "label" }, [
                  _c("p", { staticClass: "is-required" }, [
                    _c("span", { staticStyle: { color: "#F56C6C" } }, [
                      _vm._v("*")
                    ]),
                    _vm._v(" Product Photos")
                  ]),
                  _vm._v(" "),
                  _c("p", { staticClass: "sub-title" }, [
                    _vm._v(
                      "Product images showcase your product clearly and usually shot on a white background.\n            (Ideal Size: Square - 800 x 800 or higher,up to 10 sheets supported)"
                    )
                  ])
                ])
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "pro-photo" },
                [
                  _c(
                    "el-upload",
                    {
                      ref: "upload",
                      attrs: {
                        action: _vm.uploadApi,
                        "list-type": "picture-card",
                        accept: ".jpeg,.png,.jpg",
                        limit: 10,
                        "on-preview": _vm.handlePictureCardPreview,
                        "file-list": _vm.spuFilelist,
                        "on-remove": _vm.handleRemove,
                        "on-success": _vm.handleSuccess
                      },
                      on: {
                        "update:fileList": function($event) {
                          _vm.spuFilelist = $event
                        },
                        "update:file-list": function($event) {
                          _vm.spuFilelist = $event
                        }
                      }
                    },
                    [_c("i", { staticClass: "el-icon-plus" })]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: !_vm.spuFilelist || _vm.spuFilelist.length < 1,
                          expression: "!spuFilelist || spuFilelist.length<1"
                        }
                      ],
                      staticClass: "required-form-error"
                    },
                    [_vm._v("Product photos can't be blank\n        ")]
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c("div", [
            _c("div", { staticClass: "variant" }, [
              _vm._m(0),
              _vm._v(" "),
              _c(
                "div",
                [
                  _c(
                    "el-table",
                    { ref: "table", attrs: { data: _vm.table, stripe: "" } },
                    [
                      _vm._l(_vm.tableColumn, function(item, key) {
                        return [
                          item == "Image"
                            ? _c("el-table-column", {
                                key: key,
                                attrs: { label: item, width: "100" },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function(scope) {
                                        return [
                                          item == "Image"
                                            ? _c(
                                                "div",
                                                { staticClass: "tableImage" },
                                                [
                                                  _c(
                                                    "el-upload",
                                                    {
                                                      key: key,
                                                      staticClass:
                                                        "avatar-uploader",
                                                      attrs: {
                                                        action: _vm.uploadApi,
                                                        "list-type":
                                                          "picture-card",
                                                        accept:
                                                          ".jpeg,.png,.jpg",
                                                        "file-list":
                                                          _vm.skuFileList[
                                                            scope.$index
                                                          ],
                                                        limit: 1,
                                                        "on-preview":
                                                          _vm.handlePictureCardPreview,
                                                        "on-remove": function(
                                                          file,
                                                          fileList
                                                        ) {
                                                          return _vm.handleSkuRemove(
                                                            file,
                                                            fileList,
                                                            scope.$index
                                                          )
                                                        },
                                                        "on-success": function(
                                                          response,
                                                          file,
                                                          fileList
                                                        ) {
                                                          return _vm.handleSkuSuccess(
                                                            response,
                                                            file,
                                                            fileList,
                                                            scope.$index
                                                          )
                                                        }
                                                      }
                                                    },
                                                    [
                                                      scope["row"][item]
                                                        ? _c("img", {
                                                            staticClass:
                                                              "avatar",
                                                            attrs: {
                                                              src:
                                                                scope["row"][
                                                                  item
                                                                ]
                                                            }
                                                          })
                                                        : _c("i", {
                                                            staticClass:
                                                              "el-icon-plus avatar-uploader-icon"
                                                          })
                                                    ]
                                                  )
                                                ],
                                                1
                                              )
                                            : _vm._e()
                                        ]
                                      }
                                    }
                                  ],
                                  null,
                                  true
                                )
                              })
                            : item == "Brand SKU ID"
                            ? _c("el-table-column", {
                                key: key,
                                attrs: { label: item, width: "150" },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function(scope) {
                                        return [
                                          _c(
                                            "div",
                                            { staticClass: "table-cell-input" },
                                            [
                                              _c("el-input", {
                                                model: {
                                                  value: scope["row"][item],
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      scope["row"],
                                                      item,
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "scope['row'][item]"
                                                }
                                              })
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              directives: [
                                                {
                                                  name: "show",
                                                  rawName: "v-show",
                                                  value: !scope["row"][item],
                                                  expression:
                                                    "!scope['row'][item]"
                                                }
                                              ],
                                              staticClass: "required-error"
                                            },
                                            [
                                              _vm._v(
                                                "Brand SKU ID can't be blank"
                                              )
                                            ]
                                          )
                                        ]
                                      }
                                    }
                                  ],
                                  null,
                                  true
                                )
                              })
                            : item == "Case"
                            ? _c("el-table-column", {
                                key: key,
                                attrs: { label: item, width: "60" },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function(scope) {
                                        return [
                                          _c(
                                            "div",
                                            { staticClass: "table-cell-input" },
                                            [
                                              _c("el-input", {
                                                attrs: {
                                                  oninput:
                                                    "if(value){value=value.replace(/^(0+)|[^\\d]+/g,'')} if(value<=0){value=1} if(value>100){value=100}",
                                                  maxlength: 3,
                                                  minlength: 1
                                                },
                                                model: {
                                                  value: scope["row"][item],
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      scope["row"],
                                                      item,
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "scope['row'][item]"
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ]
                                      }
                                    }
                                  ],
                                  null,
                                  true
                                )
                              })
                            : item == "Procurement Price($)"
                            ? _c("el-table-column", {
                                key: key,
                                staticClass: "cust-table-column",
                                attrs: { label: item, width: "180" },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function(scope) {
                                        return [
                                          _c(
                                            "div",
                                            { staticClass: "table-cell-input" },
                                            [
                                              _c("el-input", {
                                                staticStyle: { width: "70px" },
                                                attrs: {
                                                  oninput:
                                                    "\n                              if(value){value=value.replace(/[^0-9.]/g,'')}\n                              if(value){value=value.replace(/^()*(\\d+)\\.(\\d\\d).*$/, '$1$2.$3')}\n                              "
                                                },
                                                on: {
                                                  change: function(val) {
                                                    scope["row"][item] =
                                                      val || 0
                                                  }
                                                },
                                                model: {
                                                  value: scope["row"][item],
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      scope["row"],
                                                      item,
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "scope['row'][item]"
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ]
                                      }
                                    }
                                  ],
                                  null,
                                  true
                                )
                              })
                            : item === "Wholesale Price($)"
                            ? _c("el-table-column", {
                                key: key,
                                attrs: { width: "180", label: item },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function(scope) {
                                        return [
                                          _c(
                                            "div",
                                            { staticClass: "table-cell-input" },
                                            [
                                              _c("el-input", {
                                                staticStyle: { width: "70px" },
                                                attrs: {
                                                  oninput:
                                                    "if(value){value=value.replace(/[^0-9.]/g,'')} if(value){value=value.replace(/^()*(\\d+)\\.(\\d\\d).*$/, '$1$2.$3')}"
                                                },
                                                on: {
                                                  input: function(event) {
                                                    return _vm.blurFob(
                                                      event,
                                                      scope.$index,
                                                      scope["row"]
                                                    )
                                                  }
                                                },
                                                model: {
                                                  value: scope["row"][item],
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      scope["row"],
                                                      item,
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "scope['row'][item]"
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  directives: [
                                                    {
                                                      name: "show",
                                                      rawName: "v-show",
                                                      value: !scope["row"][
                                                        item
                                                      ],
                                                      expression:
                                                        "!scope['row'][item]"
                                                    }
                                                  ],
                                                  staticClass: "required-error"
                                                },
                                                [
                                                  _vm._v(
                                                    "Wholesale Price can’t be blank"
                                                  )
                                                ]
                                              )
                                            ],
                                            1
                                          )
                                        ]
                                      }
                                    }
                                  ],
                                  null,
                                  true
                                )
                              })
                            : item === "Retail Price($)"
                            ? _c("el-table-column", {
                                key: key,
                                attrs: { width: "200", label: item },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function(scope) {
                                        return [
                                          _c(
                                            "div",
                                            { staticClass: "table-cell-input" },
                                            [
                                              _c("el-input", {
                                                staticStyle: { width: "70px" },
                                                attrs: {
                                                  oninput:
                                                    "if(value){value=value.replace(/[^0-9.]/g,'')} if(value){value=value.replace(/^()*(\\d+)\\.(\\d\\d).*$/, '$1$2.$3')}"
                                                },
                                                on: {
                                                  change: function(event) {
                                                    return _vm.blurRetailPriceFob(
                                                      event,
                                                      scope.$index,
                                                      scope["row"]
                                                    )
                                                  }
                                                },
                                                model: {
                                                  value: scope["row"][item],
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      scope["row"],
                                                      item,
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "scope['row'][item]"
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ]
                                      }
                                    }
                                  ],
                                  null,
                                  true
                                )
                              })
                            : item == "Weight(g)"
                            ? _c("el-table-column", {
                                key: key,
                                attrs: { label: item, width: "90" },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function(scope) {
                                        return [
                                          _c(
                                            "div",
                                            { staticClass: "table-cell-input" },
                                            [
                                              _c("el-input", {
                                                attrs: {
                                                  oninput:
                                                    "if(value){value=value.replace(/^(0+)|[^\\d]+/g,'')}  if(value>10000){value=10000}"
                                                },
                                                on: {
                                                  change: function(event) {
                                                    return _vm.blurWeight(
                                                      event,
                                                      scope.$index,
                                                      scope["row"]
                                                    )
                                                  }
                                                },
                                                model: {
                                                  value: scope["row"][item],
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      scope["row"],
                                                      item,
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "scope['row'][item]"
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ]
                                      }
                                    }
                                  ],
                                  null,
                                  true
                                )
                              })
                            : item == "Inventory"
                            ? _c("el-table-column", {
                                key: key,
                                attrs: { label: item, width: "190" },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function(scope) {
                                        return [
                                          _c(
                                            "div",
                                            { staticClass: "table-cell-input" },
                                            [
                                              _vm._v(
                                                "\n                    " +
                                                  _vm._s(scope["row"][item]) +
                                                  "\n                    "
                                              ),
                                              _c(
                                                "el-button",
                                                {
                                                  staticStyle: {
                                                    "margin-left": "4px",
                                                    color: "#000000",
                                                    "text-decoration":
                                                      "underline"
                                                  },
                                                  attrs: { type: "text" },
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.handleInventory(
                                                        scope.row.id
                                                      )
                                                    }
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                      View\n                    "
                                                  )
                                                ]
                                              )
                                            ],
                                            1
                                          )
                                        ]
                                      }
                                    }
                                  ],
                                  null,
                                  true
                                )
                              })
                            : item == "status"
                            ? _c("el-table-column", {
                                key: key,
                                attrs: { label: "Availability", width: "180" },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function(scope) {
                                        return [
                                          scope["row"]["showStatusSelect"]
                                            ? _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "table-cell-input"
                                                },
                                                [
                                                  _c(
                                                    "el-select",
                                                    {
                                                      attrs: {
                                                        placeholder:
                                                          "Please Select",
                                                        disabled:
                                                          _vm.goodsStatusDb ==
                                                          "0"
                                                      },
                                                      on: {
                                                        change: function(e) {
                                                          return _vm.changeSkuStatus(
                                                            e,
                                                            scope["row"],
                                                            scope.$index
                                                          )
                                                        }
                                                      },
                                                      model: {
                                                        value:
                                                          scope["row"][item],
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            scope["row"],
                                                            item,
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "scope['row'][item]"
                                                      }
                                                    },
                                                    _vm._l(
                                                      _vm.skuStatusOptions,
                                                      function(item) {
                                                        return _c("el-option", {
                                                          key: item.value,
                                                          attrs: {
                                                            label: item.label,
                                                            value: item.value
                                                          }
                                                        })
                                                      }
                                                    ),
                                                    1
                                                  )
                                                ],
                                                1
                                              )
                                            : _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "table-cell-input"
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticStyle: {
                                                        "font-size": "12px",
                                                        color: "#FB541C"
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        "Restock by " +
                                                          _vm._s(
                                                            scope["row"][
                                                              "restockDate"
                                                            ]
                                                          )
                                                      )
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "cust-sku-btn",
                                                      staticStyle: {
                                                        "text-align": "left"
                                                      }
                                                    },
                                                    [
                                                      _c(
                                                        "span",
                                                        {
                                                          on: {
                                                            click: function(
                                                              $event
                                                            ) {
                                                              return _vm.resetRestock(
                                                                scope["row"],
                                                                scope.$index
                                                              )
                                                            }
                                                          }
                                                        },
                                                        [_vm._v("Restock")]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "span",
                                                        {
                                                          on: {
                                                            click: function(
                                                              $event
                                                            ) {
                                                              scope["row"][
                                                                "tmpStatus"
                                                              ] = "99"
                                                            }
                                                          }
                                                        },
                                                        [_vm._v("Change Date")]
                                                      )
                                                    ]
                                                  )
                                                ]
                                              ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              directives: [
                                                {
                                                  name: "show",
                                                  rawName: "v-show",
                                                  value:
                                                    scope["row"]["tmpStatus"] ==
                                                    "99",
                                                  expression:
                                                    "scope['row']['tmpStatus']=='99' "
                                                }
                                              ],
                                              staticClass: "set-restock-date"
                                            },
                                            [
                                              _c("p", [
                                                _vm._v("Set restock date")
                                              ]),
                                              _vm._v(" "),
                                              _c("el-date-picker", {
                                                staticStyle: {
                                                  "margin-top": "10px"
                                                },
                                                attrs: {
                                                  type: "date",
                                                  disabled:
                                                    _vm.goodsStatusDb == "0",
                                                  "value-format": "MM/dd/yyyy",
                                                  placeholder: "MM/DD/YYYY",
                                                  format: "MM/dd/yyyy"
                                                },
                                                model: {
                                                  value: _vm.restockDate,
                                                  callback: function($$v) {
                                                    _vm.restockDate = $$v
                                                  },
                                                  expression: "restockDate"
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  directives: [
                                                    {
                                                      name: "show",
                                                      rawName: "v-show",
                                                      value: !_vm.restockDate,
                                                      expression: "!restockDate"
                                                    }
                                                  ],
                                                  staticClass: "required-error"
                                                },
                                                [
                                                  _vm._v(
                                                    "Please set restock date"
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                { staticClass: "cust-sku-btn" },
                                                [
                                                  _c(
                                                    "span",
                                                    {
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          return _vm.submitRestockDate(
                                                            scope["row"],
                                                            scope.$index,
                                                            false
                                                          )
                                                        }
                                                      }
                                                    },
                                                    [_vm._v("Cancel")]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "span",
                                                    {
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          return _vm.submitRestockDate(
                                                            scope["row"],
                                                            scope.$index,
                                                            true
                                                          )
                                                        }
                                                      }
                                                    },
                                                    [_vm._v("Save")]
                                                  )
                                                ]
                                              )
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              directives: [
                                                {
                                                  name: "show",
                                                  rawName: "v-show",
                                                  value:
                                                    _vm.goodsStatusDb == "0",
                                                  expression:
                                                    "goodsStatusDb == '0'"
                                                }
                                              ],
                                              staticClass: "required-error"
                                            },
                                            [
                                              _vm._v(
                                                "Please set SPU Active first"
                                              )
                                            ]
                                          )
                                        ]
                                      }
                                    }
                                  ],
                                  null,
                                  true
                                )
                              })
                            : item == "Dimensions - L/W/H(cm)"
                            ? _c("el-table-column", {
                                key: key,
                                attrs: { label: item, width: "200" },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function(scope) {
                                        return [
                                          _c(
                                            "div",
                                            { staticClass: "table-cell-input" },
                                            [
                                              _c("el-input", {
                                                staticStyle: { width: "50px" },
                                                attrs: {
                                                  oninput:
                                                    "if(value){value=value.replace(/^(0+)|[^\\d]+/g,'')} if(value>1000){value=1000}",
                                                  placeholder: "Length"
                                                },
                                                model: {
                                                  value: scope["row"]["length"],
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      scope["row"],
                                                      "length",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "scope['row']['length']"
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c("el-input", {
                                                staticStyle: { width: "50px" },
                                                attrs: {
                                                  oninput:
                                                    "if(value){value=value.replace(/^(0+)|[^\\d]+/g,'')}  if(value>1000){value=1000}",
                                                  placeholder: "Width"
                                                },
                                                model: {
                                                  value: scope["row"]["width"],
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      scope["row"],
                                                      "width",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "scope['row']['width']"
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c("el-input", {
                                                staticStyle: { width: "50px" },
                                                attrs: {
                                                  oninput:
                                                    "if(value){value=value.replace(/^(0+)|[^\\d]+/g,'')}  if(value>1000){value=1000}",
                                                  placeholder: "High"
                                                },
                                                model: {
                                                  value: scope["row"]["height"],
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      scope["row"],
                                                      "height",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "scope['row']['height']"
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ]
                                      }
                                    }
                                  ],
                                  null,
                                  true
                                )
                              })
                            : item !== "length" &&
                              item !== "width" &&
                              item !== "height" &&
                              item !== "countryCode" &&
                              item !== "serviceFee" &&
                              item !== "isDirectlyModifyNetPrice" &&
                              item !== "orlNetPrice" &&
                              item !== "restockDate"
                            ? _c("el-table-column", {
                                key: key,
                                attrs: {
                                  label: item,
                                  width: _vm.calcWidth(item)
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function(scope) {
                                        return [
                                          _c("div", [
                                            _vm._v(_vm._s(scope["row"][item]))
                                          ])
                                        ]
                                      }
                                    }
                                  ],
                                  null,
                                  true
                                )
                              })
                            : _vm._e()
                        ]
                      })
                    ],
                    2
                  )
                ],
                1
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "content" }, [
              _vm._m(1),
              _vm._v(" "),
              _c(
                "div",
                [
                  _c(
                    "el-radio-group",
                    {
                      on: { change: _vm.changeCommodityAttributes },
                      model: {
                        value: _vm.form.commodityAttributes,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "commodityAttributes", $$v)
                        },
                        expression: "form.commodityAttributes"
                      }
                    },
                    [
                      _c("el-radio", { attrs: { label: 4 } }, [
                        _vm._v("Ordinary")
                      ]),
                      _vm._v(" "),
                      _c("el-radio", { attrs: { label: 1 } }, [
                        _vm._v("Sensitive")
                      ]),
                      _vm._v(" "),
                      _c("el-radio", { attrs: { label: 2 } }, [
                        _vm._v("Cosmetic")
                      ]),
                      _vm._v(" "),
                      _c("el-radio", { attrs: { label: 3 } }, [
                        _vm._v("Apparel")
                      ])
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("el-checkbox", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.isAdmin,
                        expression: "isAdmin"
                      }
                    ],
                    staticStyle: { "margin-left": "20px" },
                    attrs: { label: "Special", name: "type" },
                    on: { change: _vm.changeIsSpecial },
                    model: {
                      value: _vm.form.isSpecial,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "isSpecial", $$v)
                      },
                      expression: "form.isSpecial"
                    }
                  })
                ],
                1
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "content" }, [
              _vm._m(2),
              _vm._v(" "),
              _c("div", { staticClass: "flex" }, [
                _c(
                  "div",
                  { staticStyle: { "margin-right": "20px" } },
                  [
                    _c("span", { staticClass: "cust-name" }, [
                      _vm._v("SPU Customs Name_cn")
                    ]),
                    _vm._v(" "),
                    _c("el-input", {
                      staticClass: "cust-name-input",
                      attrs: { maxlength: "50", "show-word-limit": "" },
                      on: { blur: _vm.inputCnChange },
                      nativeOn: {
                        keyup: function($event) {
                          return _vm.inputCnChange.apply(null, arguments)
                        },
                        keydown: function($event) {
                          return _vm.inputCnChange.apply(null, arguments)
                        }
                      },
                      model: {
                        value: _vm.form.cnProductName,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "cnProductName", $$v)
                        },
                        expression: "form.cnProductName"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  [
                    _c("span", { staticClass: "cust-name" }, [
                      _vm._v("SPU Customs Name_en")
                    ]),
                    _vm._v(" "),
                    _c("el-input", {
                      staticClass: "cust-name-input",
                      attrs: {
                        maxlength: "50",
                        onkeyup: "value=value.replace(/[^\\x00-\\xff]/g, '')",
                        "show-word-limit": ""
                      },
                      model: {
                        value: _vm.form.enProductName,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "enProductName", $$v)
                        },
                        expression: "form.enProductName"
                      }
                    })
                  ],
                  1
                )
              ])
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "content" },
              [
                _vm._m(3),
                _vm._v(" "),
                _c(
                  "el-select",
                  {
                    attrs: { placeholder: "Please Select" },
                    model: {
                      value: _vm.form.goodsStatus,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "goodsStatus", $$v)
                      },
                      expression: "form.goodsStatus"
                    }
                  },
                  _vm._l(_vm.goodsStatusOptions, function(item) {
                    return _c("el-option", {
                      key: item.value,
                      attrs: { label: item.label, value: item.value }
                    })
                  }),
                  1
                ),
                _vm._v(" "),
                _vm.form["reviewContentList"]
                  ? _c(
                      "div",
                      {
                        staticClass: "required-form-error",
                        staticStyle: { "margin-top": "13px" }
                      },
                      [
                        _vm._v(
                          "\n          modify is " +
                            _vm._s(
                              _vm._f("disUpdateAfterValueStatus")(
                                _vm.form["reviewContentList"]
                              )
                            ) +
                            ", under review\n        "
                        )
                      ]
                    )
                  : _vm._e()
              ],
              1
            )
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "button-list", staticStyle: { "margin-top": "20px" } },
        [
          _c(
            "el-button",
            {
              staticClass: "save-button",
              attrs: { type: "primary" },
              on: { click: _vm.save }
            },
            [_vm._v("\n      save\n    ")]
          ),
          _vm._v(" "),
          _c("el-button", { attrs: { plain: "" }, on: { click: _vm.cancel } }, [
            _vm._v("\n      cancel\n    ")
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: { visible: _vm.dialogVisible },
          on: {
            "update:visible": function($event) {
              _vm.dialogVisible = $event
            }
          }
        },
        [
          _c("img", {
            attrs: { width: "100%", src: _vm.dialogImageUrl, alt: "" }
          })
        ]
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "variant-title" }, [
      _c("p", [_vm._v("Variant")]),
      _vm._v(" "),
      _c("p", { staticClass: "sub-title" }, [
        _vm._v(
          "Add variants to your product if it comes in more than one option such as size or\n            color."
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _c("span", { staticStyle: { color: "#F56C6C" } }, [_vm._v("*")]),
      _vm._v(" Commodity attributes")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _c("span", { staticStyle: { color: "#F56C6C" } }, [_vm._v("*")]),
      _vm._v(" Customs Name")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _c("span", { staticStyle: { color: "#F56C6C" } }, [_vm._v("*")]),
      _vm._v(" Status")
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-f514c334", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f514c334","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/spuDetails/wholesale-spu-detail.vue
// module id = az+v
// module chunks = 2